import { render } from "./informefotografico.vue?vue&type=template&id=3aed8ba0"
import script from "./informefotografico.vue?vue&type=script&lang=js"
export * from "./informefotografico.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__